import { Message } from "element-ui";
import NProgress from "nprogress";
import i18n from "./i18n";
import { menuRoutes, headquartersSetupRoutes } from "./router";
import { formatRouter } from "@/utils";

// 进度条配置
NProgress.inc(0.2);
NProgress.configure({
	easing: "ease",
	speed: 500,
	showSpinner: false
});

// 路由白名单
const whiteList = ["/login"];

export const setupRouterGuard = (router, store) => {
	// 路由守卫
	router.beforeEach((to, _, next) => {
		document.title = to.meta.title;
		NProgress.start();
		const token = localStorage.getItem("token");
		const initRoute = store.state.user.initRoute;
		const permissions = store.getters.permissions;
		// 当前路由
		const currentRoutes = router.getRoutes();
		// 动态路由
		const dynamicRoutes = formatRouter(menuRoutes, permissions);

		if (whiteList.includes(to.path)) {
			next();
		} else {
			if (!token) {
				Message.error(i18n.tc("pleaseLogin"));
				next("/login");

				return;
			}

			if (!initRoute) {
				// 初始化系统路由
				dynamicRoutes.forEach((route) => {
					const routeExists = currentRoutes.some((r) => r.name === route.name);

					if (!routeExists) {
						router.addRoute("root", route);
					}
				});

				// 初始化总部设置路由
				if (!currentRoutes.some((r) => r.name === headquartersSetupRoutes.name)) {
					router.addRoute(headquartersSetupRoutes);
				}

				store.commit("user/SET_INIT_ROUTE", true);

				if (to.path === "/") {
					// 如果是根路径，跳转到第一个有子节点的路由
					const nextRoute = dynamicRoutes.find((route) => route.component);

					next(nextRoute.path);

					return;
				}

				const isDynamicRoute = dynamicRoutes.some((route) => route.path === to.path);
				const isHeadquartersRoute = headquartersSetupRoutes.children.some((route) => route.path === to.path);

				// 重新跳转到目标路由
				if (isDynamicRoute || isHeadquartersRoute) {
					next({ path: to.path, replace: true });
				} else {
					next();
				}
			} else {
				if (to.path === "/") {
					// 如果是根路径，跳转到第一个有子节点的路由
					const nextRoute = dynamicRoutes.find((route) => route.component);

					next(nextRoute.path);

					return;
				}

				next();
			}
		}
	});

	// 路由守卫
	router.afterEach(() => {
		NProgress.done();
	});
};
